var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2727_47473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53344 14.5C11.5697 14.5 14.8722 9.4978 14.8722 5.16124C14.8722 5.02062 14.8691 4.87687 14.8628 4.73624C15.5052 4.27164 16.0597 3.69617 16.5 3.03687C15.9017 3.30307 15.2664 3.47692 14.6159 3.55249C15.3009 3.14194 15.8137 2.49698 16.0594 1.73718C15.415 2.11904 14.7104 2.38841 13.9756 2.53374C13.4806 2.00771 12.826 1.65941 12.1131 1.5427C11.4003 1.42599 10.6688 1.54737 10.0318 1.88806C9.39486 2.22876 8.88787 2.7698 8.58923 3.42754C8.2906 4.08528 8.21695 4.82308 8.37969 5.52687C7.075 5.46139 5.79862 5.12247 4.63332 4.53207C3.46802 3.94166 2.4398 3.11296 1.61531 2.09968C1.19627 2.82216 1.06804 3.6771 1.25669 4.49073C1.44534 5.30436 1.93671 6.01563 2.63094 6.47999C2.10975 6.46344 1.59998 6.32312 1.14375 6.07062V6.11124C1.14328 6.86943 1.4054 7.60439 1.88554 8.19118C2.36568 8.77797 3.03422 9.18037 3.7775 9.32999C3.2947 9.46209 2.78799 9.48133 2.29656 9.38624C2.5063 10.0383 2.91438 10.6086 3.46385 11.0176C4.01331 11.4265 4.67675 11.6537 5.36156 11.6675C4.19895 12.5807 2.76278 13.0761 1.28438 13.0737C1.02219 13.0733 0.760266 13.0573 0.5 13.0256C2.0019 13.9892 3.74902 14.5009 5.53344 14.5Z",
    fill: "#34544F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2727_47473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.c5b097de90541087242095f61efdcc02.svg";
export { ForwardRef as ReactComponent };